import { LayoutImageComponentAPI } from '../../../api/files/LayoutImageComponentAPI';

export class ImageCommand {
    constructor() {
        this.layoutImageComponentApi = new LayoutImageComponentAPI();
    }

    getAll(successCallback, errorCallback) {
        const apiResult = this.layoutImageComponentApi.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }
        });
    }

    save(data, successCallback, errorCallback) {
        if (0 >= data.url.length) {
            return;
        }

        let dataToSend = new FormData();
        dataToSend.append("id", data.id);
        dataToSend.append("url", data.url);
        dataToSend.append("rotationAngle", data.rotationAngle);
        dataToSend.append("opacity", data.opacity);
        dataToSend.append("file", data.file);

        let apiResult = undefined;
        if (0 === dataToSend.get("id") || "0" === dataToSend.get("id")) {
            apiResult = this.layoutImageComponentApi.create(dataToSend);
        }
        else {
            apiResult = this.layoutImageComponentApi.update(dataToSend.id, dataToSend);
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a criar a imagem");
            }
        });
    }

    delete(imageId, successCallback, errorCallback) {
        const apiResult = this.layoutImageComponentApi.delete(imageId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Imagem eliminada com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a eliminar a imagem");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/ImageCommand.js